import { galleryImagePath } from "../../api/client";

import { ReactionBar } from "./ReactionBar";

import type { ApiErrorCode } from "../../api/client";
import type {
  GalleryPostCard,
  GalleryReactionState,
} from "@canvaschool/contracts";

export const cardLabel = (post: GalleryPostCard): string =>
  `${post.school.name} · ${post.className}`;

/** Lazy image that keeps its shape while loading. */
export const GalleryImage = ({
  post,
  eager = false,
}: {
  post: GalleryPostCard;
  eager?: boolean;
}) => (
  <img
    className="canvaschool-gallery-image"
    src={galleryImagePath(post.id)}
    alt={`${cardLabel(post)} 학생 작품`}
    width={post.width}
    height={post.height}
    loading={eager ? "eager" : "lazy"}
    decoding="async"
    style={{ aspectRatio: `${post.width} / ${post.height}` }}
  />
);

export const GalleryCard = ({
  post,
  onOpen,
  onReaction,
  onError,
}: {
  post: GalleryPostCard;
  onOpen: () => void;
  onReaction: (state: GalleryReactionState) => void;
  onError: (code: ApiErrorCode) => void;
}) => (
  <li className="canvaschool-gallery-card">
    <button
      type="button"
      className="canvaschool-gallery-open"
      aria-label={`${cardLabel(post)} 작품 크게 보기`}
      onClick={onOpen}
    >
      <GalleryImage post={post} />
    </button>
    <p className="canvaschool-gallery-caption">{cardLabel(post)}</p>
    <ReactionBar post={post} onChange={onReaction} onError={onError} />
  </li>
);
